import React, { useEffect, useState } from "react";
import { Modal, Input, Button, message } from "antd";
// import { useDispatch, useSelector } from "react-redux";
import { VideoList } from "./VideoList";
// import { addVideo, reorderVideo } from "../store/action/video";
// import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { useCreateVideo, useGetAllVideos, useReorderVideos } from "../utils/queryUtils";

const VideoListModal = ({ setIsModelOpen, isModalOpen }) => {
  // const dispatch = useDispatch();
  const [selected, setSelected] = useState("");
  const { data, isLoading: loading } = useGetAllVideos();
  const videos = data;
  const [items, setItems] = useState([]);
  const { mutateAsync: createVideo } = useCreateVideo();
  const { mutateAsync: reorderVideo } = useReorderVideos()

  useEffect(() => {
    setItems(videos);
  }, [videos]);

  useEffect(() => {

  }, [items])

  const submit = async () => {
    if (!selected) {
      message.error("Please add a video link");
      return;
    }
    if (selected) {
      const params = new URL(selected);
      if (params.host !== "youtu.be" && params.host !== "www.youtube.com") {
        message.error("Please provide a valid YouTube link");
        return;
      }
      setSelected("");
      // setIsModelOpen(false);
      // dispatch(addVideo(selected));
      await createVideo(selected)
    }
  };

  const cancelHandler = () => {
    setIsModelOpen(false);
  };

  const handleDragEnd = async (event) => {
    if (!event.destination) return;

    const oldIndex = event.source.index;
    const newIndex = event.destination.index;

    if (oldIndex === newIndex) return;

    setItems((items) => {
      const newItems = [...items];
      const [removed] = newItems.splice(oldIndex, 1);
      newItems.splice(newIndex, 0, removed);
      const reorderedItems = newItems.map((e, i) => ({
        ...e,
        videoIndex: i + 1
      }));

      reorderVideo(reorderedItems);
      return reorderedItems;
    });

  }

  return (
    <Modal
      open={isModalOpen}
      width={600}
      onCancel={cancelHandler}
      title={<h6 className="font-semibold m-0">Add new Video to help center</h6>}
      okText="ADD VIDEO"
      onOk={submit}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ loading: loading }}
      footer={<></>}
    >
      <label>Video Url</label>
      <div className="d-flex gap-4">
        <Input value={selected} onChange={(ev) => setSelected(ev.target.value)} />
        <Button onClick={submit} type="primary">
          Add Video
        </Button>
      </div>

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {items?.length > 0 && items.map((el, index) => (
                <VideoList key={`${el.id}-${index}`} el={el} index={index} />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default VideoListModal;
